import {Banner} from '@primer/react'
import {SkipIcon} from '@primer/octicons-react'
import {useSessionContext} from '../../contexts/SessionContext'
import {useAgentInfo} from '../../hooks/use-agent-info'
import {renderTextWithLinks} from '../../utils/render-text-with-links'

interface SessionCancelledBannerProps {
  cancellationMessage: string | null
  workflowRunLink: string | null
}

export function SessionCancelledBanner({cancellationMessage, workflowRunLink}: SessionCancelledBannerProps) {
  const {session} = useSessionContext()
  const {data: agentInfo} = useAgentInfo(session.agent_id, session.agent_slug)
  const defaultCancellationMessage = 'The session was cancelled.'
  const sessionCancelledMessage = cancellationMessage || defaultCancellationMessage
  return (
    <Banner
      aria-label="Session Cancelled"
      title={`${agentInfo?.display_name || 'Agent'}'s work was cancelled`}
      description={renderTextWithLinks(sessionCancelledMessage)}
      variant="warning"
      icon={<SkipIcon />}
      primaryAction={
        workflowRunLink && (
          <Banner.PrimaryAction as="a" href={workflowRunLink}>
            View detailed logs
          </Banner.PrimaryAction>
        )
      }
    />
  )
}
